import { KJUR, KEYUTIL, hextob64 } from 'jsrsasign';

function formatAsJavaDateString(k: string, v: string): string {
   const date = new Date(v.replace(' ', 'T')); // 更好兼容性
   if (!isNaN(date.getTime())) {
      const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const day = DAYS[date.getDay()];
      const month = MONTHS[date.getMonth()];
      const dayOfMonth = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();
      const timeStr = [
         date.getHours(),
         date.getMinutes(),
         date.getSeconds()
      ].map(n => n.toString().padStart(2, '0')).join(':');

      const tz = 'CST';

      return `${k}=${day} ${month} ${dayOfMonth} ${timeStr} ${tz} ${year}`;
   }
   return `${k}=${v}`;
}

/**
 * 将参数转换为 Java 风格签名字符串：
 * - key 升序排序
 * - 过滤 null 和空字符串
 * - 排除 sign 字段
 * - 数组转为 "[a, b]" 格式
 */
export function getOriginalStr(data: Record<string, any>): string {
   return Object.keys(data)
      .filter(k => {
         const v = data[k];
         return k !== 'sign' && v !== null && v !== '';
      })
      .sort()
      .map(k => {
         const v = data[k];

         if (typeof v === 'string') {
            // 检查是否为日期字符串格式
            const isDateTime = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(v);
            const isDate = /^\d{4}-\d{2}-\d{2}$/.test(v);

            if (isDateTime || isDate) {
               return formatAsJavaDateString(k, v);
            }
            return `${k}=${v}`;
         }

         if (Array.isArray(v)) {
            return `${k}=[${v.join(', ')}]`;
         }

         if (typeof v === 'object' && v !== null) {
            return `${k}=${v.toString?.() || JSON.stringify(v)}`;
         }

          // 处理数字类型,模拟Java的数字格式
         //  if (typeof v === 'number') {
         //    if (Number.isInteger(v)) {
         //       return `${k}=${v}.0`;
         //    }
         // }

         return `${k}=${v}`; // number, boolean 等
      })
      .join('&');
}

/**
 * 标准化私钥格式为 PEM
 */
function normalizePrivateKey(key: string): string {
   if (!key || typeof key !== 'string') {
      throw new Error('私钥不能为空，且必须是字符串');
   }

   const trimmed = key.trim();
   if (trimmed.startsWith('-----BEGIN') && trimmed.includes('PRIVATE KEY')) {
      return trimmed;
   }

   const lines = trimmed.match(/.{1,64}/g);
   if (!lines) throw new Error('私钥格式不正确，可能缺失');

   return `-----BEGIN PRIVATE KEY-----\n${lines.join('\n')}\n-----END PRIVATE KEY-----`;
}

/**
 * 使用 SHA256withRSA 生成签名（Base64）
 */
export function rsaSign(params: Record<string, any>, privateKey: string): string {
   try {
      const originalStr = getOriginalStr(params);
      console.log('[🔍 签名前字符串]', originalStr); // ✅ 调试输出

      const pemKey = normalizePrivateKey(privateKey);
      const keyObj = KEYUTIL.getKey(pemKey);

      const sig = new KJUR.crypto.Signature({ alg: 'SHA256withRSA' });
      sig.init(keyObj);
      sig.updateString(originalStr);

      const hexSign = sig.sign();
      const base64 = hextob64(hexSign);
      console.log('[🔐 签名结果 Base64]', base64);

      return base64;
   } catch (err: unknown) {
      const error = err as Error;
      console.error('❌ RSA 签名失败:', error.message);
      throw new Error(`签名失败: ${error.message}`);
   }
}
